/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  downloadLink?: string;
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'Earth Day Unprintable',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1O',
    textDescription:
      'Geoffrey and his friends are goin’ to pieces, and it’s up to the kiddos to put ‘em back together again! But before all that happens, these jungle pals need some coloring. That’ll help kids identify which pieces belong to each animal. Then cut on the dotted line, mix up the parts and let your wild one have a roarin’ good time!<br/><br/>Parents, use #ShareThePlay on social media so we can see how they did!',
    downloadLink:
      'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZYf',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
            <a href={this.printPage.downloadLink} className='print-download-link' target='_blank'>download
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
